
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

type TotalResultsProps = {
  totalPoints: number;
  globalIndex: number;
};

export const TotalResults = ({ totalPoints, globalIndex }: TotalResultsProps) => {
  const { t } = useTranslation('results');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl text-golf-700">{t('total.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4 text-center">
          <div className="p-4 bg-golf-50 rounded-lg">
            <div className="text-lg font-semibold text-golf-700">{t('total.totalPoints')}</div>
            <div className="text-3xl font-bold text-golf-800">{totalPoints}</div>
          </div>
          <div className="p-4 bg-golf-50 rounded-lg">
            <div className="text-lg font-semibold text-golf-700">{t('total.finalIndex')}</div>
            <div className="text-3xl font-bold text-golf-800">{globalIndex}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
